<template>
  <div>
    <quill-editor
      ref="qeditor"
      v-model:content="content"
      content-type="html"
      @input="updateField"
      :options="editorOption"
    >
      >
    </quill-editor>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor, Quill } from 'vue-quill-editor';
import 'quill-divider';
import ImageResize from 'quill-image-resize-vue';
Quill.register('modules/imageResize', ImageResize);
import MagicUrl from 'quill-magic-url';
Quill.register('modules/magicUrl', MagicUrl);
var icons = Quill.import('ui/icons');
icons['undo'] = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>
    <path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path>
  </svg>`;
icons['redo'] = `<svg viewbox="0 0 18 18">
    <polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>
    <path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path>
  </svg>`;

export default {
  components: {
    'quill-editor': quillEditor,
  },
  props: ['value'],
  computed: {
    // a computed getter
    editorOption: function() {
      var Delta = Quill.import('delta');

      // `this` points to the vm instance
      return {
        modules: {
          history: {
            delay: 1000,
            maxStack: 500,
            userOnly: true,
          },

          clipboard: {
            matchVisual: false,
            matchers: [
              [
                Node.ELEMENT_NODE,
                function(node, delta) {
                  return delta.compose(
                    new Delta().retain(delta.length(), {
                      background: false,
                    }),
                  );
                },
              ],

              // [Node.TEXT_NODE, (node, delta) => {
              //     if(node.data.match(/^\s/) ) {
              //         const Delta = Quill.import('delta');
              //         return new Delta().insert(node.data);
              //     }
              //     return delta;
              // }],
            ],
          },
          imageResize: {
            // See optional "config" below
          },
          magicUrl: true,
          divider: true,
          toolbar: {
            container: [
              ['bold', 'italic', 'strike', 'underline', 'link'],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ list: 'bullet' }, { list: 'ordered' }],
              ['blockquote'],
              ['image'],
              ['divider'],
              ['undo', 'redo'],
            ],
            handlers: {
              redo() {
                this.quill.history.redo();
              },
              undo() {
                this.quill.history.undo();
              },
              //redo: this.myRedo,
            },
          },
        },
      };
    },
  },
  data() {
    return {
      content: this.value,
    };
  },
  methods: {
    updateField: function(value) {
      this.$emit('input', String(value));
    },
    myUndo: function() {
      //let myEditor = this.$refs.qeditor.getEditor();
      return this.$refs.qeditor.history.undo();
    },
    myRedo: function() {
      //let myEditor = this.$refs.qeditor.getEditor();
      return this.$refs.qeditor.history.redo();
    },
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        // Note: `newValue` will be equal to `oldValue` here
        // on nested mutations as long as the object itself
        // hasn't been replaced.
        this.content = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style>
.ql-container {
  height: 300px !important;
}
.ql-editor p {
  margin-bottom: 15px !important;
}
.ql-clipboard {
  white-space: normal;
}

.ql-undo {
  content: 'undo';
  font-family: 'Material Icons';
}
</style>
